import React from "react";
import { Link as RouterLink, matchPath, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { Link, Typography, Breadcrumbs as MuiBreadcrumbs, } from "@material-ui/core";
import { NavigateNext } from "@material-ui/icons";
import { paths } from "frontend/src/pages/paths/index";
import { useParams } from "react-router";
import { Skeleton } from "@material-ui/lab";
import { clientsCacheKey } from "frontend/src/domain/client/shared";
var url = paths.admin;
var routes = [
    { name: "Главная", url: url.home() },
    { name: "Клиенты", url: url.clients.index() },
    {
        name: function (client, id) {
            var _a, _b, _c;
            var data = client.getQueryData([clientsCacheKey, id]);
            if (!data)
                return false;
            return (_b = (_a = data.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = data.user) === null || _c === void 0 ? void 0 : _c.email;
        },
        url: url.clients.view(":id"),
    },
    { name: "Плейлисты", url: url.playlists.index() },
    { name: "Редактирование", url: url.playlists.edit(":id") },
];
var mapPathName = function (pathname) {
    return routes.filter(function (_a) {
        var url = _a.url;
        return matchPath(pathname, { path: url, exact: false, strict: false });
    });
};
export var Breadcrumbs = function () {
    var queryClient = useQueryClient();
    var params = useParams();
    var pathname = useLocation().pathname;
    var id = Number(params.id);
    var paths = mapPathName(pathname);
    return (React.createElement(MuiBreadcrumbs, { separator: React.createElement(NavigateNext, { fontSize: "small" }) }, paths.map(function (_a, index, array) {
        var name = _a.name, url = _a.url;
        var value = typeof name === "function"
            ? name(queryClient, id) || React.createElement(Skeleton, { width: 100 })
            : name;
        return index < array.length - 1 ? (React.createElement(Link, { component: RouterLink, color: "inherit", to: url, key: index }, name)) : (React.createElement(Typography, { color: "textPrimary", key: index }, value));
    })));
};
